import type { JSX } from 'react'

import { Icon, IconNames, IconSizes } from 'atoms/Icon'
import { TextBox } from 'atoms/TextBox'
import { Colors, TextAligning, TextBoxTypes } from 'atoms/TextBox/TextBox.h'
import { GeoblockUnavailableSC } from './GeoblockUnavailable.styled'

export interface IGeoblockUnavailableProps {
  title: string
}

export const GeoblockUnavailable = ({
  title,
}: IGeoblockUnavailableProps): JSX.Element => (
  <GeoblockUnavailableSC>
    <Icon
      name={IconNames.geoblock}
      color={Colors.TEXT_ICON_SECONDARY}
      size={IconSizes.xLarge}
    />
    <TextBox
      title={title}
      color={Colors.TEXT_ICON_SECONDARY}
      font={TextBoxTypes.FontXlBold}
      alignment={TextAligning.Center}
      maxLines={2}
    />
  </GeoblockUnavailableSC>
)
